import * as React from 'react';
import React__default, { useState, useCallback, useEffect, memo } from 'react';
import { NotificationManager, Space, Typography, FormControl, MaskInput, Icon, TextInput, Button, Dialog, Logo } from '@sravni/react-design-system';
import { useAnalytics, useBoolean, useIsMobile } from '@sravni/react-utils';
import { _ as __assign, a as __awaiter, b as __generator, c as __read } from './chunks/tslib.es6-ebb56484.js';
import { e as eq_1, _ as _isIndex, i as isObject_1, a as _baseKeys, b as _getTag, c as isArguments_1, d as isArray_1, f as isArrayLike_1, g as isBuffer$1, h as _isPrototype, j as isTypedArray_1 } from './chunks/isTypedArray-a816ffbf.js';
import { _ as _baseAssignValue, a as _castPath, b as _toKey, c as _baseGet, h as hasIn_1, d as _baseFlatten, e as _overRest, f as _setToString } from './chunks/_setToString-1146b653.js';
import './chunks/toString-744b752a.js';

var modules_3d2af0d9 = {"popup":"_1xiks75","header":"_4omtdr","logo":"_1zcr1k"};
/*SRAVNI__src/components/AuthPopup/src/auth-popup.module.scss__SRAVNI*/;

/**
 * @description Check icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Check } from '@sravni/design-system-icons'
 *
 * <Check />
 * ```
 */
var Check = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Check", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m6 11 3 3 6-7", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

var AUTH_FIELDS = ["phone" /* PHONE */];
var PHONE_MASK = [
    '+',
    '7',
    ' ',
    '(',
    /[1-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
];

var modules_b993082e = {"wrapper":"_ogdxdi","heading":"_gfio3j","fieldsWrapper":"_1xhgd91","iconCheck":"_c7qydt"};
import "./assets/AuthPopup.css";

var rules$1 = [
  // if it says it's a webview, let's go with that
  'WebView',
  // iOS webview will be the same as safari but missing "Safari"
  '(iPhone|iPod|iPad)(?!.*Safari)',
  // Android Lollipop and Above: webview will be the same as native but it will contain "wv"
  // Android KitKat to Lollipop webview will put Version/X.X Chrome/{version}.0.0.0
  'Android.*(;\\s+wv|Version/\\d.\\d\\s+Chrome/\\d+(\\.0){3})',
  // old chrome android webview agent
  'Linux; U; Android'
];

var rules = rules$1;
var webviewRegExp = new RegExp('(' + rules.join('|') + ')', 'ig');

var isUaWebview = function isWebview(ua) {
  return !!ua.match(webviewRegExp)
};

class AuthError extends Error {
    constructor(params) {
        const { message = "Auth Unknown error" } = params || {};
        super(message);
        // capturing the stack trace keeps the reference to your error class
        if (Error.captureStackTrace !== undefined) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}

class AuthWindowBlockedError extends AuthError {
    constructor(params) {
        const { message = "Child window for authentication was blocked" } = params || {};
        super({ message });
    }
}

class AuthWindowClosedError extends AuthError {
    constructor(params) {
        const { message = "Child window for authentication was closed" } = params || {};
        super({ message });
    }
}

var baseAssignValue = _baseAssignValue,
    eq = eq_1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$1(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$1.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue$1;

var assignValue = _assignValue,
    castPath$1 = _castPath,
    isIndex = _isIndex,
    isObject = isObject_1,
    toKey = _toKey;

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet$1(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath$1(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

var _baseSet = baseSet$1;

var baseGet = _baseGet,
    baseSet = _baseSet,
    castPath = _castPath;

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy$1(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

var _basePickBy = basePickBy$1;

var basePickBy = _basePickBy,
    hasIn = hasIn_1;

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick$1(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

var _basePick = basePick$1;

var baseFlatten = _baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

var flatten_1 = flatten$1;

var flatten = flatten_1,
    overRest = _overRest,
    setToString = _setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest$1(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

var _flatRest = flatRest$1;

var basePick = _basePick,
    flatRest = _flatRest;

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/naming-convention */
const AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME = "AUTH_PAGE_SUCCESSFULL_LOGIN";
const AUTH_FAILURE_LOGIN_MESSAGE_NAME = "AUTH_PAGE_FAILURE_LOGIN";
const AUTH_ROUTER_PREFIX_DEFAULT = "/openid/v2";
/**
 * @enum Типы ошибок
 */
var ACCESS_DENIED_REASON;
(function (ACCESS_DENIED_REASON) {
    /** Неизвестная ошибка */
    ACCESS_DENIED_REASON["UNKNOWN"] = "unknown";
    // ЕСИА
    /** Аккаунт ЕСИА уже привязан к другому пользователю */
    ACCESS_DENIED_REASON["ESIA_ACCOUNT_ALREADY_LINKED"] = "EsiaAccountAlreadyLinked";
    /** У пользователя уже есть привязанный аккаунт ЕСИА */
    ACCESS_DENIED_REASON["USER_ALREADY_HAS_ESIA_ACCOUNT"] = "UserAlreadyHasEsiaAccount";
    /** Во время авторизации в ЕСИА возникла не предвиденная проблема */
    ACCESS_DENIED_REASON["ESIA_AUTH_FAILED"] = "EsiaAuthFailed";
    /** Пользователь ЕСИА отказался предоставлять данные*/
    ACCESS_DENIED_REASON["ESIA_CONSENT_FAILED"] = "EsiaConsentFailed";
    /** Пользователь не подтвержден ЕСИА и не может запрашивать разрешения */
    ACCESS_DENIED_REASON["ESIA_USER_IS_NOT_VERIFIED"] = "EsiaUserIsNotVerified";
    /** Неполучилось скачать данные о пользователе ЕСИА (фио,снилс, и т.д.) */
    ACCESS_DENIED_REASON["FAILED_TO_FETCH_USER_INFO_FROM_ESIA"] = "FailedToFetchUserInfoFromEsia";
    /**
     * Неполучилось залогинится через ЕСИА,
     * ошибка может возникнуть на этапе логина пользователя в Identity(cохранение/обновление пользователя в бд и httpContext.Signin)
     */
    ACCESS_DENIED_REASON["FAILED_TO_LOGIN_VIA_ESIA"] = "FailedToLoginViaEsia";
    // ЕСИА
    // TBank
    /**
     * Неполучилось залогинится через TBANK,
     * ошибка может возникнуть на этапе логина пользователя в Identity(cохранение/обновление пользователя в бд и httpContext.Signin)
     */
    ACCESS_DENIED_REASON["FAILED_TO_LOGIN_VIA_TBANK"] = "FailedToLoginViaTBank";
    /** Во время авторизации в TBank возникла не предвиденная проблема */
    ACCESS_DENIED_REASON["TBANK_AUTH_FAILED"] = "TBankAuthFailed";
    /** Аккаунт TBank уже привязан к другому пользователю */
    ACCESS_DENIED_REASON["TBANK_ACCOUNT_ALREADY_LINKED"] = "TBankAccountAlreadyLinked";
    /** У пользователя уже есть привязанный аккаунт TBank */
    ACCESS_DENIED_REASON["USER_ALREADY_HAS_TBANK_ACCOUNT"] = "UserAlreadyHasTBankAccount";
    // TBank
    // Sber
    /**
     * Неполучилось залогинится через Sber,
     * ошибка может возникнуть на этапе логина пользователя в Identity(cохранение/обновление пользователя в бд и httpContext.Signin)
     */
    ACCESS_DENIED_REASON["FAILED_TO_LOGIN_VIA_SBER"] = "FailedToLoginViaSber";
    /** Во время авторизации в Sber возникла не предвиденная проблема */
    ACCESS_DENIED_REASON["SBER_AUTH_FAILED"] = "SberAuthFailed";
    /** Аккаунт Sber уже привязан к другому пользователю */
    ACCESS_DENIED_REASON["SBER_ACCOUNT_ALREADY_LINKED"] = "SberAccountAlreadyLinked";
    /** У пользователя уже есть привязанный аккаунт Sber */
    ACCESS_DENIED_REASON["USER_ALREADY_HAS_SBER_ACCOUNT"] = "UserAlreadyHasSberAccount";
    // Sber
    /** Не хватает данных для показа пользователю соглашений */
    ACCESS_DENIED_REASON["NOT_ENOUGH_INFO_FOR_USER_AGREEMENTS"] = "NotEnoughInfoForUserAgreements";
    /** Не удалось сохранить данные необходимые для подписи согласий */
    ACCESS_DENIED_REASON["FAILED_TO_STORE_DATA_FOR_SIGN"] = "FailedToStoreDataForSign";
    /** Не удалось подписать пользовательские соглашения */
    ACCESS_DENIED_REASON["FAILED_TO_SIGN_USER_AGREEMENTS"] = "FailedToSignUserAgreements";
    /** Ошибки при запросе к сервису пользовательских соглашений */
    ACCESS_DENIED_REASON["FAILED_TO_REQUEST_USER_AGREEMENTS_SERVICE"] = "FailedToRequestUserAgreementsService";
    /** Не удалось получить данные для подписи пользовательских соглашений */
    ACCESS_DENIED_REASON["FAILED_TO_FETCH_DATA_FOR_USER_AGREEMENTS"] = "FailedToFetchDataForUserAgreements";
    /** Не удалось начать загрузку документов из ЕСИА (ПФР, НДФЛ, и. т.д.) */
    ACCESS_DENIED_REASON["FAILED_TO_START_LOADING_DOCUMENTS_FROM_ESIA"] = "FailedToStartLoadingDocumentsFromEsia";
    /** Не найден пользователь для привязки */
    ACCESS_DENIED_REASON["FAILED_TO_FIND_USER_FOR_LINKING"] = "FailedToFindUserForLinking";
})(ACCESS_DENIED_REASON || (ACCESS_DENIED_REASON = {}));
var ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS;
(function (ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS) {
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["PASSPORT_SERIES"] = "PassportSeries";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["PASSPORT_NUMBER"] = "PassportNumber";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["PASSPORT_ISSUED_BY"] = "PassportIssuedBy";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["PASSPORT_ISSUER_ID"] = "PassportIssuerId";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["PASSPORT_ISSUE_DATE"] = "PassportIssueDate";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["SNILS"] = "Snils";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["INN"] = "Inn";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["BIRTHPLACE"] = "BirthPlace";
    ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS["BIRTHDATE"] = "BirthDate";
})(ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS || (ESIA_ENOUGH_INFO_FOR_USER_AGREEMENTS_KEYS = {}));
var AUTHENTICATION_UI_TYPE;
(function (AUTHENTICATION_UI_TYPE) {
    AUTHENTICATION_UI_TYPE["POPUP"] = "popup";
    AUTHENTICATION_UI_TYPE["PAGE"] = "page";
})(AUTHENTICATION_UI_TYPE || (AUTHENTICATION_UI_TYPE = {}));
var QUERY;
(function (QUERY) {
    QUERY["TYPE"] = "type";
    QUERY["REFERER"] = "referer";
    QUERY["RETURN_URL"] = "returnUrl";
    QUERY["REDIRECT"] = "redirect";
    QUERY["LOGIN_TYPE"] = "loginType";
    QUERY["LOGOUT_TYPE"] = "logoutType";
    QUERY["ACTION"] = "action";
    QUERY["PROMPT"] = "prompt";
    // Значение не совпадает специально, чтобы не было видно в гет параметрах что это связано с пользователем
    QUERY["USER_NAME"] = "hash";
    QUERY["TIMEOUT_EXPIRED"] = "timeoutExpired";
    QUERY["PIN_DISABLED"] = "pinDisabled";
    QUERY["PLACEMENT"] = "placement";
    QUERY["PRODUCT_ID"] = "productId";
    QUERY["BANNER_URL"] = "bannerUrl";
    QUERY["ESIA_TYPE"] = "esiaType";
    QUERY["OTAC"] = "otac";
    QUERY["HINT"] = "hint";
    // @deprecated
    QUERY["OT"] = "ot";
    // @deprecated
    QUERY["ACR_VALUES"] = "acr_values";
})(QUERY || (QUERY = {}));
/** Типы авторизации */
var LOGIN_TYPE;
(function (LOGIN_TYPE) {
    LOGIN_TYPE["PHONE"] = "phone";
    LOGIN_TYPE["EMAIL"] = "email";
    LOGIN_TYPE["ESIA"] = "esia";
    LOGIN_TYPE["TBANK"] = "tbank";
    LOGIN_TYPE["SBER"] = "sber";
    LOGIN_TYPE["OTAC"] = "otac";
})(LOGIN_TYPE || (LOGIN_TYPE = {}));
/** ПодТипы типа авторизации */
var ESIA_TYPE;
(function (ESIA_TYPE) {
    ESIA_TYPE["OPTIONAL"] = "optional";
    ESIA_TYPE["STRICT"] = "strict";
})(ESIA_TYPE || (ESIA_TYPE = {}));
/** Типы логаута */
var LOGOUT_TYPE;
(function (LOGOUT_TYPE) {
    LOGOUT_TYPE["SIMPLE"] = "simple";
})(LOGOUT_TYPE || (LOGOUT_TYPE = {}));
var ROUTES;
(function (ROUTES) {
    // Урлы для login
    ROUTES["LOGIN"] = "/login/";
    ROUTES["LOGIN_CONFIRM"] = "/login/confirm/";
    ROUTES["CALLBACK"] = "/callback/";
    ROUTES["SUCCESS"] = "/success/";
    // Урлы для logout
    ROUTES["LOGOUT"] = "/logout/";
    ROUTES["LOGOUT_CALLBACK"] = "/logout/callback/";
    ROUTES["SILENT_SIGNIN"] = "/silent/signin/";
    ROUTES["SILENT_SIGNIN_VERIFY"] = "/silent/signin/verify/";
    ROUTES["LOADING"] = "/loading/";
    // CrossDomains
    ROUTES["IFRAMES"] = "/crossdomains/iframes/";
    ROUTES["ACTION"] = "/crossdomains/action/";
})(ROUTES || (ROUTES = {}));

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable max-statements */
const mockDomain = "http://test.com";
const getLoginUrl = (options) => {
    const { webPath, returnUrl, loginType, esiaType, isNewWindow = false, otac, ot, pinDisabled, placement, productId, 
    // eslint-disable-next-line @typescript-eslint/naming-convention
    acr_values, hint, prompt, bannerUrl, prefix = AUTH_ROUTER_PREFIX_DEFAULT, } = options || {};
    const hasWebPath = Boolean(webPath);
    const loginUrl = new URL(`${prefix}${ROUTES.LOGIN}`, hasWebPath ? webPath : mockDomain);
    if (returnUrl) {
        loginUrl.searchParams.append(QUERY.RETURN_URL, returnUrl);
    }
    if (loginType) {
        loginUrl.searchParams.append(QUERY.LOGIN_TYPE, loginType);
    }
    if (esiaType) {
        loginUrl.searchParams.append(QUERY.ESIA_TYPE, esiaType);
    }
    if (ot) {
        loginUrl.searchParams.append(QUERY.OT, ot);
    }
    if (otac) {
        loginUrl.searchParams.append(QUERY.OTAC, otac);
    }
    if (acr_values) {
        loginUrl.searchParams.append(QUERY.ACR_VALUES, acr_values);
    }
    if (hint) {
        loginUrl.searchParams.append(QUERY.HINT, hint);
    }
    if (prompt) {
        loginUrl.searchParams.append(QUERY.PROMPT, prompt);
    }
    if (isNewWindow) {
        loginUrl.searchParams.append(QUERY.TYPE, AUTHENTICATION_UI_TYPE.POPUP);
    }
    if (typeof pinDisabled === "boolean") {
        loginUrl.searchParams.append(QUERY.PIN_DISABLED, pinDisabled.toString());
    }
    if (bannerUrl) {
        loginUrl.searchParams.append(QUERY.BANNER_URL, bannerUrl);
    }
    if (placement) {
        loginUrl.searchParams.append(QUERY.PLACEMENT, placement);
    }
    if (productId) {
        loginUrl.searchParams.append(QUERY.PRODUCT_ID, productId);
    }
    return hasWebPath
        ? loginUrl.toString()
        : `${loginUrl.pathname}${loginUrl.search}`;
};
const getLoadingUrl = (options) => {
    const { webPath, prefix = AUTH_ROUTER_PREFIX_DEFAULT, timeoutExpired } = options || {};
    const hasWebPath = Boolean(webPath);
    const loadingUrl = new URL(`${prefix}${ROUTES.LOADING}`, hasWebPath ? webPath : mockDomain);
    if (timeoutExpired)
        loadingUrl.searchParams.append(QUERY.TIMEOUT_EXPIRED, timeoutExpired.toString());
    return hasWebPath
        ? loadingUrl.toString()
        : `${loadingUrl.pathname}${loadingUrl.search}`;
};

// Функция создает уникальный слушатель события POST message.
// При отправке нужного post message между вкладками браузера, будет вызван callback что передан в последний вызов функции subscribeOnLoginSuccess
const subscribeOnLoginSuccess = (callback) => {
    if (typeof window === "undefined") {
        return () => { };
    }
    const uniqSymbol = Symbol("Uniq key for post message handler work");
    window.sravni = {
        ...window.sravni,
        authentication: {
            // eslint-disable-next-line no-undef
            ...(window.sravni?.authentication ?? {}),
            loginSuccessPostMessageSymbol: uniqSymbol,
        },
    };
    const handler = (event) => {
        const canExecuteCallback = window.sravni.authentication.loginSuccessPostMessageSymbol ===
            uniqSymbol;
        if (!canExecuteCallback) {
            return false;
        }
        const message = event.data;
        const sourceWindow = event.source;
        if (typeof message.authMessageType !== "undefined" &&
            message.authMessageType === AUTH_SUCCESSFULL_LOGIN_MESSAGE_NAME &&
            typeof message !== "undefined" &&
            message.payload === true) {
            if (sourceWindow && sourceWindow.constructor.name === "Window")
                sourceWindow.close();
            callback();
        }
    };
    window.addEventListener("message", handler, false);
    return () => {
        window.sravni.authentication.loginSuccessPostMessageSymbol =
            undefined;
        window.removeEventListener("message", handler, false);
    };
};
// Функция создает уникальный слушатель события POST message.
// При отправке нужного post message между вкладками браузера, будет вызван callback что передан в последний вызов функции subscribeOnLoginFailure
const subscribeOnLoginFailure = (callback) => {
    if (typeof window === "undefined") {
        return () => { };
    }
    const uniqSymbol = Symbol("Uniq key for post message handler work");
    window.sravni = {
        ...window.sravni,
        authentication: {
            // eslint-disable-next-line no-undef
            ...(window.sravni?.authentication ?? {}),
            loginFailurePostMessageSymbol: uniqSymbol,
        },
    };
    const handler = (event) => {
        const canExecuteCallback = window.sravni.authentication.loginFailurePostMessageSymbol ===
            uniqSymbol;
        if (!canExecuteCallback) {
            return false;
        }
        const message = event.data;
        if (typeof message.authMessageType !== "undefined" &&
            message.authMessageType === AUTH_FAILURE_LOGIN_MESSAGE_NAME &&
            typeof message !== "undefined" &&
            message.payload === true) {
            callback();
        }
    };
    window.addEventListener("message", handler, false);
    return () => {
        window.sravni.authentication.loginFailurePostMessageSymbol =
            undefined;
        window.removeEventListener("message", handler, false);
    };
};

/*
 * Helper for login by otac.
 * Solves problems: window modal size, window modal position, blocking window modal by browser.
 */
class AuthLoginByOtacHelper {
    params;
    _childWindow;
    constructor(params) {
        const { isWebview, ...rest } = params;
        this._childWindow = null;
        this.params = {
            isWebview: typeof isWebview === "boolean" ? isWebview : this._getIsWebView(),
            ...rest
        };
    }
    _getIsWebView() {
        if (typeof window === "undefined")
            return;
        if (typeof window.navigator === "undefined")
            return;
        const ua = window.navigator.userAgent;
        return isUaWebview(ua);
    }
    _getWindowFeatures(width, height) {
        const getSilentAuthModalPosition = (width, height) => {
            if (typeof window === "undefined")
                return null;
            // Fixes dual-screen position                             Most browsers      Firefox
            const screenDualLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const screenDualTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
            const screenWidth = window.innerWidth ||
                document.documentElement.clientWidth ||
                window.screen.width;
            const screenHeight = window.innerHeight ||
                document.documentElement.clientHeight ||
                window.screen.height;
            const top = (screenHeight - height) / 2 + screenDualTop;
            const left = (screenWidth - width) / 2 + screenDualLeft;
            return {
                top,
                left,
            };
        };
        const modalPosition = getSilentAuthModalPosition(width, height);
        return `width=${width}, height=${height}, top=${modalPosition ? modalPosition.top : 0}, left=${modalPosition ? modalPosition.left : 0}`;
    }
    _getWindowParams() {
        const { type, width = 430, height = 600 } = this.params;
        const isNewWindow = ["modal", "tab"].includes(type);
        const target = isNewWindow ? "_blank" : undefined;
        const features = ["modal"].includes(type)
            ? this._getWindowFeatures(width, height)
            : undefined;
        return {
            isNewWindow,
            target,
            features,
        };
    }
    _startChildWindowCloseWatcher(callback) {
        if (typeof window === "undefined")
            return undefined;
        if (!this._childWindow)
            return undefined;
        return setInterval(() => {
            if (!this._childWindow ||
                this._childWindow.window === null ||
                this._childWindow.window === undefined ||
                this._childWindow.closed) {
                callback();
            }
        }, 500);
    }
    _startChildWindowTimeoutWatcher(timeout, callback) {
        if (typeof window === "undefined")
            return undefined;
        if (!this._childWindow)
            return undefined;
        return setTimeout(() => {
            callback();
        }, timeout);
    }
    _loginByChildWindow(params) {
        if (typeof this._childWindow === "undefined") {
            throw new Error('No window defined. Call method "prepare" first');
        }
        const { prefix, webPath, analytics: { productId } = {} } = this.params;
        const { otac, hint } = params;
        const { isNewWindow } = this._getWindowParams();
        const url = getLoginUrl({
            otac,
            hint,
            prefix,
            webPath,
            loginType: "otac",
            isNewWindow,
            // Это нужно для логина под новым юзером, даже если мы уже залогинены под каким-то другим
            prompt: "login",
            productId,
        });
        return new Promise((resolve, reject) => {
            const childWindowCloseWatcherId = this._startChildWindowCloseWatcher(() => {
                clearInterval(childWindowCloseWatcherId);
                reject(new AuthWindowClosedError());
            });
            subscribeOnLoginSuccess(() => {
                clearInterval(childWindowCloseWatcherId);
                this.destroy();
                resolve();
            });
            subscribeOnLoginFailure(() => {
                clearInterval(childWindowCloseWatcherId);
                this.destroy();
                reject(new AuthError());
            });
            if (this._childWindow) {
                this._childWindow.location.href = url;
                // Хак. не уверен что он работает
                this._childWindow.blur();
                setTimeout(this._childWindow.focus, 0);
            }
        });
    }
    _loginByRedirects(params) {
        const { prefix, webPath, analytics: { productId } = {} } = this.params;
        const { otac, hint } = params;
        const url = getLoginUrl({
            otac,
            hint,
            prefix,
            webPath,
            loginType: "otac",
            // Это нужно для логина под новым юзером, даже если мы уже залогинены под каким-то другим
            prompt: "login",
            productId,
        });
        window.location.href = url;
        return Promise.resolve(); // Для единого выходного интерфейса
    }
    /*
     * Must be called AFTER user action and BEFORE long js task (like ajax request)
     */
    prepare(params) {
        if (typeof window === "undefined")
            return;
        if (this.params.isWebview)
            return;
        const { timeout = 10000, onError } = params || {};
        const { window: { title = "Вход на сайт | Сравни.ру" } = {}, prefix, webPath, } = this.params;
        const { target, features } = this._getWindowParams();
        const loadingUrl = getLoadingUrl({ prefix, webPath, timeoutExpired: Date.now() + timeout });
        // Сафари ругается при исполнении этого кода - window.open внутри async
        // Сафари не дает открыть новое окно если функция 'prepare' лежит в обработчике события. ОТ этого спасает setTimeout
        return new Promise((resolve, reject) => {
            const childWindow = window.open(loadingUrl, target, features);
            if (!childWindow) {
                // Так как код выполняется в setTimeout - то выбрасывание исключения через throw не будет перехвачено try catch над методом prepare
                if (typeof onError === "function") {
                    onError(new AuthWindowBlockedError());
                    return;
                }
                reject(new AuthWindowBlockedError());
                return;
            }
            this._childWindow = childWindow;
            this._childWindow.document.title = title;
            // Запускаем таймер на макс время открытия доп вкладки
            this._startChildWindowTimeoutWatcher(timeout, () => this.destroy());
            resolve();
            // Хак. не уверен что он работает
            window.blur();
            setTimeout(window.focus, 0);
        });
    }
    /*
     * Implements login and error handling
     */
    login(params) {
        if (typeof window === "undefined")
            return Promise.resolve();
        const { isWebview } = this.params;
        if (isWebview)
            return this._loginByRedirects(params);
        return this._loginByChildWindow(params);
    }
    destroy() {
        if (typeof window === "undefined")
            return undefined;
        // При вызове этого кода синхронно сафари на ios теряет указатель на this._childWindow
        // А при отложенном вызове он есть
        setTimeout(() => {
            if (!this._childWindow) {
                return undefined;
            }
            this._childWindow.close();
            this._childWindow = null;
        }, 0);
    }
}

var intervals = {
    smsCountdownInMilliseconds: 1000
};
var timeouts = {
    authInMilliseconds: 3000,
    initialSmsTimeoutInSeconds: 30,
    logoutInMilliseconds: 3000
};

var PhoneConfirmationInitialState = {
    phone: '',
    status: 'required',
    loading: false
};
var SmsCodeStatusInitialState = {
    timeout: 0,
    errorMessage: null
};

var tryAuth = function (authHelper, _a) {
    var otac = _a.otac, username = _a.username;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, authHelper.login({ otac: otac, hint: username })];
                case 1:
                    _b.sent();
                    window.location.reload();
                    return [3 /*break*/, 3];
                case 2:
                    _b.sent();
                    authHelper.destroy();
                    throw new Error('Ошибка аутентификации');
                case 3: return [2 /*return*/];
            }
        });
    });
};

var baseKeys = _baseKeys,
    getTag = _getTag,
    isArguments = isArguments_1,
    isArray = isArray_1,
    isArrayLike = isArrayLike_1,
    isBuffer = isBuffer$1.exports,
    isPrototype = _isPrototype,
    isTypedArray = isTypedArray_1;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

var isEmpty_1 = isEmpty;

var ALPHA_REGEX = /^[-A-ZА-ЯЁ ]+$/i;
var ONLY_MOBILE_DEF_CODES = [
    900, 901, 902, 903, 904, 905, 906, 908, 909, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923,
    924, 925, 926, 927, 928, 929, 930, 931, 932, 933, 934, 936, 937, 938, 939, 950, 951, 952, 953, 958, 960, 961, 962,
    963, 964, 965, 966, 967, 968, 969, 977, 978, 980, 981, 982, 983, 984, 985, 986, 987, 988, 989, 991, 992, 993, 994,
    995, 996, 997, 999,
];
var validateText = function (value) {
    return typeof value !== 'undefined' && ALPHA_REGEX.test(value);
};
var validatePhone = function (value) {
    value = value.replace(/[-_()\s]/g, '');
    var defCode = /^(8|\+7|7)\(?(\d{3})\)?[\d]{7,10}$/g.exec(value);
    return defCode !== null && ONLY_MOBILE_DEF_CODES.indexOf(parseInt(defCode[2], 10)) !== -1;
};
var validateField = function (name, value) {
    if (isEmpty_1(value))
        return false;
    switch (name) {
        case "name" /* NAME */:
            return value.length > 1 && validateText(value);
        case "code" /* CODE */:
            return value.length > 2;
        case "phone" /* PHONE */:
            return validatePhone(value);
        default:
            return true;
    }
};
// export const validateFields = (formValues) => {
//   let isValid = true;
//
//   Object.values(AUTH_FIELDS_NAMES).forEach((key) => {
//     if (formValues[key] && !validateField(key, formValues[key].value)) {
//       isValid = false;
//     }
//   });
//
//   return isValid;
// };

var decorateFormValues = function (values) {
    return Object.fromEntries(Object.entries(values).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return [key, value.value];
    }));
};
var useAuthForm = function (_a) {
    var _b;
    var signInUser = _a.signInUser, verifyUser = _a.verifyUser;
    var pushEvent = useAnalytics().pushEvent;
    var _c = __read(useState(PhoneConfirmationInitialState), 2), phoneConfirmation = _c[0], setPhoneConfirmation = _c[1];
    var _d = __read(useState(SmsCodeStatusInitialState), 2), smsCodeStatus = _d[0], setSmsCodeStatus = _d[1];
    var _e = __read(useBoolean(false), 2), isFormSubmitting = _e[0], setFormSubmitting = _e[1];
    var phoneConfirmationStatus = phoneConfirmation.status, isLoading = phoneConfirmation.loading;
    var smsError = smsCodeStatus.errorMessage, smsTimeout = smsCodeStatus.timeout;
    var initialValues = (_b = {},
        _b["phone" /* PHONE */] = {
            value: '',
            invalid: false,
            dirty: false,
            icon: false
        },
        _b["code" /* CODE */] = {
            value: '',
            invalid: Boolean(smsError),
            dirty: false
        },
        _b);
    var _f = __read(useState(initialValues), 2), formValues = _f[0], setFormValues = _f[1];
    var _g = __read(useState(true), 2), isBtnDisabled = _g[0], setDisableBtn = _g[1];
    var startSmsCodeTimeout = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var timeout, intervalId;
        return __generator(this, function (_a) {
            timeout = { value: timeouts.initialSmsTimeoutInSeconds };
            setSmsCodeStatus(function (prev) { return (__assign(__assign({}, prev), { timeout: timeout.value })); });
            intervalId = setInterval(function (timeLeft) { return __awaiter(void 0, void 0, void 0, function () {
                var currentTimeout;
                return __generator(this, function (_a) {
                    currentTimeout = timeLeft.value - 1;
                    setSmsCodeStatus(function (prev) { return (__assign(__assign({}, prev), { timeout: currentTimeout })); });
                    if (currentTimeout < 1) {
                        clearInterval(intervalId);
                    }
                    timeout.value = currentTimeout;
                    return [2 /*return*/];
                });
            }); }, intervals.smsCountdownInMilliseconds, timeout);
            return [2 /*return*/];
        });
    }); }, []);
    var trySendSms = useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPhoneConfirmation(function (prev) { return (__assign(__assign({}, prev), { loading: true })); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, signInUser({
                            name: values.name,
                            phone: values.phone,
                            email: values.email
                        })];
                case 2:
                    _a.sent();
                    startSmsCodeTimeout();
                    setPhoneConfirmation({
                        phone: values.phone,
                        status: 'waiting',
                        loading: false
                    });
                    return [3 /*break*/, 4];
                case 3:
                    _a.sent();
                    setPhoneConfirmation({
                        phone: '',
                        status: 'completed',
                        loading: false
                    });
                    NotificationManager.show({
                        title: 'Кажется, что-то пошло не так',
                        subtitle: '',
                        message: 'Введите другой номер или попробуйте позже',
                        timeout: 3 * 1000
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [signInUser, startSmsCodeTimeout]);
    var trySubmitSms = useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var authHelper, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPhoneConfirmation(function (prev) { return (__assign(__assign({}, prev), { loading: true })); });
                    setDisableBtn(true);
                    authHelper = new AuthLoginByOtacHelper({
                        type: 'modal'
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    authHelper.prepare();
                    return [4 /*yield*/, verifyUser({
                            code: values.code,
                            phone: values.phone
                        })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, tryAuth(authHelper, { otac: response.otac, username: response.username })];
                case 3:
                    _a.sent();
                    pushEvent({
                        event: 'mainEvent',
                        eventCategory: 'Прочее',
                        eventAction: 'Вход в ЛК',
                        eventLabel: 'Авторизация по номеру'
                    });
                    setPhoneConfirmation({
                        loading: false,
                        phone: values.phone,
                        status: 'completed'
                    });
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _a.sent();
                    setSmsCodeStatus(function (prev) { return (__assign(__assign({}, prev), { 
                        // @ts-ignore
                        errorMessage: error_2.message })); });
                    setPhoneConfirmation({
                        loading: false,
                        phone: values.phone,
                        status: 'waiting'
                    });
                    authHelper.destroy();
                    return [3 /*break*/, 6];
                case 5:
                    setDisableBtn(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [pushEvent, verifyUser]);
    var submitForm = useCallback(function (values) {
        switch (phoneConfirmationStatus) {
            case 'required':
                return trySendSms(values);
            case 'waiting':
                return trySubmitSms(values);
            case 'completed':
                return trySendSms(values);
        }
        return null;
    }, [phoneConfirmationStatus, trySendSms, trySubmitSms]);
    var validateFields = useCallback(function (values) {
        var isValid = true;
        AUTH_FIELDS.forEach(function (key) {
            if (values[key] && !validateField(key, values[key].value)) {
                isValid = false;
                setFormValues(function (prevState) {
                    var _a;
                    return __assign(__assign({}, prevState), (_a = {}, _a[key] = __assign(__assign({}, prevState[key]), { invalid: !isValid }), _a));
                });
            }
        });
        setDisableBtn(!isValid);
        return isValid;
    }, []);
    var handleSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var values;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validateFields(formValues)) return [3 /*break*/, 2];
                    values = decorateFormValues(formValues);
                    return [4 /*yield*/, submitForm(__assign({}, values))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [formValues, submitForm, validateFields]);
    var handleBlur = function (event, name) {
        var _a, _b;
        var value = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
        var isValid = validateField(name, value);
        setFormValues(function (prevState) {
            var _a;
            var _b, _c;
            return __assign(__assign({}, prevState), (_a = {}, _a[name] = __assign(__assign({}, prevState[name]), { invalid: !isValid && ((_b = prevState[name]) === null || _b === void 0 ? void 0 : _b.dirty), icon: isValid && ((_c = prevState[name]) === null || _c === void 0 ? void 0 : _c.dirty) }), _a));
        });
        if (!isValid && ((_b = formValues[name]) === null || _b === void 0 ? void 0 : _b.dirty))
            setDisableBtn(true);
    };
    var handleResendSms = function () { return __awaiter(void 0, void 0, void 0, function () {
        var values;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setFormValues(function (prevState) {
                        var _a;
                        return __assign(__assign({}, prevState), (_a = {}, _a["code" /* CODE */] = __assign(__assign({}, prevState["code" /* CODE */]), { value: '' }), _a));
                    });
                    values = decorateFormValues(formValues);
                    return [4 /*yield*/, trySendSms(values)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChangeValues = function (event, name) {
        var _a;
        // @ts-ignore TS2339: Property 'value' does not exist on type 'EventTarget'.
        var value = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
        var phoneField = name === "phone" /* PHONE */;
        var realValue = phoneField ? value.replace(/[-_()+7\s]/g, '') : value;
        var validLength = realValue.length > (phoneField ? 9 : 1);
        var isValid = true;
        if (!isValid || validLength) {
            isValid = validateField(name, value);
        }
        if (smsError) {
            setSmsCodeStatus(function (prev) { return (__assign(__assign({}, prev), { errorMessage: null })); });
        }
        setFormValues(function (prevState) {
            var _a;
            return __assign(__assign({}, prevState), (_a = {}, _a[name] = __assign(__assign({}, prevState[name]), { value: value, dirty: Boolean(realValue.length), invalid: !isValid, icon: validLength && isValid }), _a));
        });
    };
    useEffect(function () {
        if (AUTH_FIELDS.every(function (key) { return formValues[key].dirty && !formValues[key].invalid; })) {
            setDisableBtn(false);
        }
        else {
            setDisableBtn(true);
        }
    }, [formValues]);
    useEffect(function () {
        if (smsError) {
            setFormValues(function (prevState) {
                var _a;
                return __assign(__assign({}, prevState), (_a = {}, _a["code" /* CODE */] = __assign(__assign({}, prevState["code" /* CODE */]), { invalid: true }), _a));
            });
        }
    }, [smsError]);
    useEffect(function () {
        if (!isFormSubmitting && formValues.code.value.length === 4 && phoneConfirmationStatus === 'waiting') {
            setFormSubmitting.on();
            handleSubmit()["finally"](function () {
                setFormSubmitting.off();
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [phoneConfirmationStatus, formValues.code.value, handleSubmit]);
    return {
        formValues: formValues,
        phoneConfirmationStatus: phoneConfirmationStatus,
        isLoading: isLoading,
        smsTimeout: smsTimeout,
        smsError: smsError,
        isBtnDisabled: isBtnDisabled,
        handleSubmit: handleSubmit,
        handleBlur: handleBlur,
        handleResendSms: handleResendSms,
        handleChangeValues: handleChangeValues
    };
};

var AuthForm$1 = memo(function (_a) {
    var signInUser = _a.signInUser, verifyUser = _a.verifyUser;
    var _b = useAuthForm({ signInUser: signInUser, verifyUser: verifyUser }), formValues = _b.formValues, phoneConfirmationStatus = _b.phoneConfirmationStatus, isLoading = _b.isLoading, smsTimeout = _b.smsTimeout, smsError = _b.smsError, isBtnDisabled = _b.isBtnDisabled, handleBlur = _b.handleBlur, handleChangeValues = _b.handleChangeValues, handleSubmit = _b.handleSubmit, handleResendSms = _b.handleResendSms;
    var isMobile = useIsMobile();
    var buttonText = function () {
        if (smsTimeout > 0) {
            return (React__default.createElement(React__default.Fragment, null,
                "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u043A\u043E\u0434 \u043C\u043E\u0436\u043D\u043E",
                isMobile ? React__default.createElement("br", null) : ' ',
                "\u0447\u0435\u0440\u0435\u0437 00:",
                smsTimeout < 10 && '0',
                smsTimeout));
        }
        if (phoneConfirmationStatus === 'waiting') {
            return 'Запросить новый код';
        }
        return 'Получить код';
    };
    var renderFieldErrorMessage = function (field, name) {
        if (formValues[field].value.length > 50)
            return 'Слишком длинное значение';
        if (formValues[field].invalid) {
            return !formValues[field].value.length ? 'Заполните поле' : "\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 ".concat(name);
        }
        return null;
    };
    var invalidField = function (field) {
        return formValues[field].value.length > 50 || formValues[field].invalid;
    };
    var disabledField = phoneConfirmationStatus === 'waiting';
    return (React__default.createElement("div", { className: modules_b993082e.wrapper },
        React__default.createElement(Space, { className: 'h-text-center h-mb-32', direction: 'vertical', align: 'center', size: 12 },
            React__default.createElement(Typography.Heading, { level: 3, className: modules_b993082e.heading }, "\u0412\u0445\u043E\u0434 \u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F"),
            React__default.createElement(Typography.Text, { size: 14, className: 'h-color-D60' },
                "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0430\u0448 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430. \u041D\u0430 \u043D\u0435\u0433\u043E \u043C\u044B",
                React__default.createElement("br", null),
                "\u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043C \u0421\u041C\u0421 \u0441 \u043A\u043E\u0434\u043E\u043C \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F")),
        React__default.createElement(Space, { className: modules_b993082e.fieldsWrapper, direction: 'vertical' },
            React__default.createElement(Space, { direction: 'vertical', size: 12 },
                React__default.createElement(FormControl, { invalid: invalidField("phone" /* PHONE */) },
                    React__default.createElement(MaskInput, { onChange: function (e) { return handleChangeValues(e, "phone" /* PHONE */); }, onBlur: function (e) { return handleBlur(e, "phone" /* PHONE */); }, label: 'Телефон', value: formValues.phone.value, mask: PHONE_MASK, disabled: disabledField, icon: formValues.phone.icon && (React__default.createElement(Icon, { color: 'green', shape: 'circle', className: modules_b993082e.iconCheck },
                            React__default.createElement(Check, null))) }),
                    React__default.createElement(FormControl.HelperText, null, renderFieldErrorMessage("phone" /* PHONE */, 'телефона')))),
            React__default.createElement(Space, { align: 'center', direction: 'vertical', size: 20, className: 'h-mt-20' },
                phoneConfirmationStatus === 'waiting' && (React__default.createElement(FormControl, { invalid: phoneConfirmationStatus === 'waiting' && formValues.code.invalid },
                    React__default.createElement(TextInput, { onChange: function (e) { return handleChangeValues(e, "code" /* CODE */); }, onBlur: function (e) { return handleBlur(e, "code" /* CODE */); }, label: 'Код из смс', value: formValues.code.value, loading: isLoading, disabled: isLoading }),
                    smsError && formValues.code.invalid && React__default.createElement(FormControl.HelperText, null, smsError))),
                React__default.createElement(Button, { onClick: phoneConfirmationStatus === 'waiting' ? handleResendSms : handleSubmit, loading: isLoading, disabled: isBtnDisabled || smsTimeout > 0, variant: 'primary', color: 'dark', size: 60, block: true, name: 'Получить код' }, buttonText())),
            React__default.createElement(Typography.Text, { size: 12, className: 'h-mt-16 h-text-center' },
                "\u041F\u0440\u0438 \u0432\u0445\u043E\u0434\u0435 \u0432\u044B \u0441\u043E\u0433\u043B\u0430\u0448\u0430\u0435\u0442\u0435\u0441\u044C \u0441",
                ' ',
                React__default.createElement("a", { href: 'https://www.sravni.ru/about/privacy-policy/' }, "\u043F\u0440\u0430\u0432\u0438\u043B\u0430\u043C\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438")))));
});

var AuthPopup$1 = memo(function (_a) {
    var showPopup = _a.showPopup, handleClose = _a.handleClose, signInUser = _a.signInUser, verifyUser = _a.verifyUser;
    return (React__default.createElement(Dialog, { visible: showPopup, onClose: handleClose, className: modules_3d2af0d9.popup },
        React__default.createElement(Dialog.Header, { className: modules_3d2af0d9.header, title: React__default.createElement(Logo, { className: modules_3d2af0d9.logo }) }),
        React__default.createElement(Dialog.Content, null,
            React__default.createElement(AuthForm$1, { signInUser: signInUser, verifyUser: verifyUser }))));
});

export { AuthPopup$1 as AuthPopup };
